import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
    mutation customerAccessTokenCreate(
        $input: CustomerAccessTokenCreateInput!
    ) {
        customerAccessTokenCreate(input: $input) {
            customerUserErrors {
                code
                field
                message
            }
            customerAccessToken {
                accessToken
                expiresAt
            }
        }
    }
`;

export const SIGNUP_MUTATION = gql`
    mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
            customer {
                id
            }
            customerUserErrors {
                code
                field
                message
            }
        }
    }
`;

export const ORDERS_QUERY = gql`
    query fetchUserOrders($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
            orders(first: 5) {
                edges {
                    node {
                        id
                        customerUrl
                        processedAt
                        statusUrl
                        successfulFulfillments {
                            trackingCompany
                            trackingInfo {
                                number
                                url
                            }
                        }
                        totalPriceV2 {
                            amount
                        }
                        email
                        orderNumber
                        shippingAddress {
                            address1
                            address2
                            city
                            firstName
                            lastName
                        }
                        lineItems(first: 5) {
                            edges {
                                node {
                                    quantity
                                    title

                                    variant {
                                        id
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const USER_QUERY = gql`
    query fetchUser($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
            firstName
            lastName
            email
            id
        }
    }
`;

export const SINGLE_PRODUCT_QUERY = gql`
    query fetchSingleProduct($handle: String!) {
        productByHandle(handle: $handle) {
            title
            availableForSale
            priceRange {
                maxVariantPrice {
                    amount
                }
            }
            handle
            images(first: 10) {
                edges {
                    node {
                        id
                    }
                }
            }
            productType
            tags
            title
            variants(first: 50) {
                edges {
                    node {
                        selectedOptions {
                            name
                            value
                        }
                        id
                        title
                        image {
                            id
                            originalSrc
                        }
                        priceV2 {
                            amount
                        }
                    }
                }
            }
        }
    }
`;
